// 9fbef606107a605d69c0edbcd8029e5d
import { parseBoolean } from '@tcp/core/src/utils';

export const getAccountNavigationState = (state) => {
  return state.AccountReducer && state.AccountReducer.get('accountNavigation');
};

export const getAccountNavigationFetchingState = (state) => {
  return state.AccountReducer && state.AccountReducer.get('isFetching');
};

export const getAccountRichTextContent = (state) => {
  return state.AccountReducer && state.AccountReducer.get('richTextContent');
};

export const getMPRCCBenefits = (state) => {
  return (
    state.AccountReducer && state.AccountReducer.getIn(['richTextContent', 'mprccBenefits'], '')
  );
};

export const getResetPasswordSuccessMsg = (state) => {
  return (
    state.AccountReducer &&
    state.AccountReducer.getIn(['richTextContent', 'reset_password_check_email_message'], '')
  );
};

export const isShippingOnAccountPage = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_SHIPPIING_ON_ACCOUNT_PAGE)
  );
};
